import { provide, ref } from "vue";

export const useRuntimeTemplate = (templateUrl, cssUrl, queryUrl, fallbackTemplateFn = null, fallbackCssFn = null) => {
    const templateContent = ref(null);
    const query = ref(null);

    const loadCSS = (cssContent) => {
        if (cssContent) {
            const style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.appendChild(document.createTextNode(cssContent));
            document.head.appendChild(style);
        }
    };

    const getFileContent = async (url) => {
        try {
            const response = await fetch(url);
            if (response.ok) {
                return await response.text();
            }
        } catch (e) {
            console.error(e);
            return '';
        }
    };

    const getQuery = async () => {
        if (queryUrl) {
            const queryContent = await getFileContent(queryUrl);
            if (queryContent) {
                query.value = queryContent;
                return true;
            }
        }
        return false;
    };

    const getTemplateContent = async () => {
        if (templateUrl) {
            const template = await getFileContent(templateUrl);
            if (template) {
                templateContent.value = template;
                return true;
            }
        }

        if (fallbackTemplateFn) {
            const { default: fallbackTemplate } = await fallbackTemplateFn();
            templateContent.value = fallbackTemplate || null;
        }
        return false;
    };

    const getCssContent = async () => {
        if (cssUrl) {
            const css = await getFileContent(cssUrl);
            if (css) {
                loadCSS(css);
                return true;
            }
        }

        if (fallbackCssFn) {
            const { default: fallbackCss } = await fallbackCssFn();
            loadCSS(fallbackCss);
        }
        return false;
    };

    provide('query', query);

    const getTemplate = async () => {
        return Promise.allSettled([getTemplateContent(), getCssContent(), getQuery()]);
    };

    return {
        templateContent,
        getTemplate
    };
};